import { BrowserRouter } from 'react-router-dom';
import { Container } from './styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { useEffect } from 'react';
import Illustration from '../../assets/illustration.svg';
import { NavHashLink } from 'react-router-hash-link';
import linkedin from '../../assets/linkedin.svg';
import githubIcon from '../../assets/github.svg';
import Hello from '../../assets/Hello.gif';
export function Hero() {
  useEffect(() => {
    // Force scroll event after component mounts to trigger initial animations
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
      // Also try triggering a resize event
      window.dispatchEvent(new Event('resize'));
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOnce
          animatePreScroll={false}
        >
          <p>
            Hi <img src={Hello} alt="Hello" width="20px" />, I'm
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInUp"
          delay={0.2 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <h1>Johnny Gipson</h1>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInUp"
          delay={0.4 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <h3>Enterprise Architect</h3>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInUp"
          delay={0.6 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <p className="small-resume">15+ Years Experience</p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInUp"
          delay={0.8 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <BrowserRouter>
            <NavHashLink smooth to="#contact" className="button">
              Contact
            </NavHashLink>
          </BrowserRouter>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInUp"
          delay={1 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <div className="social-media">
            <a
              href="https://www.linkedin.com/in/johnny-gipson/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="Linkedin" />
            </a>
            <a
              href="https://github.com/jgipson360"
              target="_blank"
              rel="noreferrer"
            >
              <img src={githubIcon} alt="GitHub" />
            </a>
          </div>
        </ScrollAnimation>
      </div>
      <div className="hero-image">
        <ScrollAnimation
          animateIn="fadeInRight"
          delay={1.2 * 1000}
          animateOnce
          animatePreScroll={false}
        >
          <img src={Illustration} alt="Ilustração" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
